<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Дата начала периода</label>
                <date-component v-model="currFilters.dateFrom"/>
            </div>
            <div class="form-group">
                <label>Дата окончания периода</label>
                <date-component v-model="currFilters.dateTo"/>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            
          <div class="form-group select2">
            <div class="d-flex align-items-center">
              <label class="mr-2">Отобразить в отчете</label>
              <Checkbox v-model="fieldsChecked"
                        :checked="fieldsChecked"
                        id="fieldsSpec1"
                        text="Все поля"
              />
            </div>
                <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                         v-model="currFilters.fields"/>
            </div>
            

        </div>
      <div class="form-group col-2 px-0">
        <div class="card-footer px-0 d-flex">
          <button-component @click="apply" class="btn-xs">Сформировать</button-component>
          <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
          <button class="btn-success btn-d btn-xs" @click="exportReport">
            <i class="fa fa-download"></i>Экспорт</button>
        </div>
      </div>
    </div>
</template>

<script>
  import DateComponent from "../../../common/components/DateComponent";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import NsiApi from "../../admin/api/nsi";
  import Api from "../api/vacancy";
  import {useVuelidate} from '@vuelidate/core'
  import Constants from '../../../common/constants'
  import moment from 'moment'
  import Checkbox from "@/common/ui/checkbox";

  const dateLessValidator = (value) => value == null || value <= moment(new Date()).format("YYYY-MM-DD");

  export default {
    name: "ReportRasFilter",
    components: {Checkbox, ButtonComponent, DateComponent},
    props: {
      filters: Object
    },
    data() {
      return {
        fieldsChecked: true,
        districts: [],
        fields: [],
        currFilters: this.filters
      }
    },
    created() {
      this.loadDictionaries();
    },
    watch: {
      fieldsChecked: {
        handler(val) {
          if(val === true) {
            this.currFilters.fields = this.fields.map(item => item.id)
          }
          if(val === false) {
            this.currFilters.fields = []
          }
        },
        deep: true
      },

    },
    methods: {
      loadDictionaries() {
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        Api.getReportFields()
          .then((response) => {
            this.fields = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      apply() {

        this.v$.$touch();
            if (this.v$.$invalid) {
              Constants.alert.fire('Ошибка', 'Поле "Дата начала периода" не может быть больше текущей даты', 'error');
              return;
            }

        const filters = Object.assign({}, this.currFilters);
        this.$emit('apply', filters);
      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          districtIds: [],          
          fields: ['District', 'Search', 'Work', 'WorkAndSearch']
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        const filters = Object.assign({}, this.currFilters);
        this.$emit('exportReport', filters);
      }
    },

    setup: () => ({v$: useVuelidate()}),
    validations() {
        return {
            currFilters: {
                dateFrom: {
                  dateLessValidator
                }
            }
        }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .btn-d{
      min-width: 120px;
        border: none;
        padding: 14px 24px;
        border-radius: 24px;
        i{
            padding-right: 12px;
        }
    }
</style>